<template>

  <div class="vflex">
    <div class="vflex-row-1">

      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">

        <Paginaty
          :total="paginate.total"
          :pages="paginate.pages"
          :page="paginate.page"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="header">
            <div class="d-flex flex-wrap">
              <div 
                class="mr-2" 
                v-if="selected.length">
                <JobMassiveAction />
              </div>
              <div class="ml-auto">
                <div class="btn-row">
                  <button
                    v-if="permissions.includes('manage_candidates')"
                    type="button"
                    class="btn btn-secondary"
                    @click="showCandidateCreateModal">
                    + {{ $t('New candidate') }}
                  </button>

                  <div class="dropdown">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle"
                      type="button"
                      data-toggle="dropdown">
                    </button>
                    <div class="dropdown-menu">
                      <button
                        class="dropdown-item"
                        @click="showExport = true">
                        {{ $t('Export xlsx') }}
                        </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <DataimexExportModal
              v-if="showExport === true"
              @close="showExport = false"
              :promise="exportCandidates" />
          </template>

          <template slot="content">
            <table class="table table-hover">
              <thead class="table-thead-sticky">
                <tr>
                  <th width="10"><input type="checkbox" @click="toggleCheckAll" :checked="checkedAll"></th>
                  <th width="50"></th>
                  <th-sort field="name" :value="sort" @input="setSort">{{ $t('Name') }}</th-sort>
                  <th-sort field="city" :value="sort" @input="setSort">{{ $t('Location') }}</th-sort>
                  <th-sort field="avg_rating.evaluation" :value="sort" @input="setSort">{{ $t('Evaluation') }}</th-sort>
                  <th-sort field="avg_rating.questionnaire" :value="sort" @input="setSort">{{ $t('Tests') }}</th-sort>
                  <th-sort field="avg_rating.intervideo" :value="sort" @input="setSort">{{ $t('Video') }}</th-sort>
                  <th-sort field="placements.elemMatch.match_score" :value="sort" @input="setSort" v-if="resourceAvailability.features.includes('matcher')">{{ $t('Match Score') }}</th-sort>
                  <th-sort field="created_at" :value="sort" @input="setSort">{{ $t('Created at') }}</th-sort>
                  <th>{{ $t('Stage') }}</th>
                  <th width="20"></th>
                </tr>
              </thead>
              <tbody>
                <job-grid-item
                  v-for="(candidate, index) in candidates"
                  :key="index"
                  :candidate="candidate"
                  :keywords="filters.text">
                  </job-grid-item>
              </tbody>
            </table>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </filterfy>
    </div>

    <div 
      class="vflex-row-0"
      v-if="candidate_create_modal">
      <candidate-create-form
        @hideModal="hideCandidateCreateModal"
        @saved="savedCandidateCreateModal" 
        :initCandidate="candidate_create_modal">
        </candidate-create-form>
    </div>

  </div>

</template>

<script>
import ThSort from '@/components/Parts/ThSort'
import CandidateCreateForm from '@/components/CandidateCreateForm/CandidateCreateForm'
import Filterfy from '@/components/Filterfy/Filterfy'
import JobMassiveAction from '../JobMassiveAction/JobMassiveAction'
import JobGridItem from './JobGridItem'
import Paginaty from '@/components/Paginaty/Paginaty'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import DataimexExportModal from '@/components/Dataimex/DataimexExportModal'

export default {
  name: 'JobGrid',
  components: {
    ThSort,
    Filterfy,
    CandidateCreateForm,
    JobMassiveAction,
    JobGridItem,
    Paginaty,
    DataimexExportModal
  },
  data () {
    return {
      creating: true,
      loading: true,
      candidate_create_modal: false,
      showExport: false,
      filtersMap: [
        {
          'type': 'fulltext',
          'label': this.$t('Keywords'),
          'target': 'text'
        },
        /* {
          'type': 'keyword',
          'label': this.$t('City'),
          'target': 'city'
        }, */
        {
          'type': 'list',
          'label': this.$t('New'),
          'target': 'placements.elemMatch.new',
          'resource': 'candidate_new'
        },
        {
          'type': 'list',
          'label': 'Status',
          'target': 'placements.elemMatch.status',
          'resource': 'placement_status'
        },
        {
          'type': 'list',
          'label': this.$t('Stage'),
          'target': 'placements.elemMatch.stage_id',
          'resource': 'stages'
        },
        {
          'type': 'slider-range',
          'label': this.$t('Evaluation'),
          'target': 'avg_rating.evaluation',
          'min': 0,
          'max': 100,
          'interval': 25,
          'format': '{value}%'
        },
        {
          'type': 'list',
          'label': this.$t('Tags'),
          'target': 'tags',
          'resource': 'candidate-tags'
        },
        {
          'type': 'list',
          'label': this.$t('Experience level'),
          'target': 'experience_level',
          'resource': 'experience_level'
        },
        {
          'type': 'list',
          'label': this.$t('Education degree'),
          'target': 'educations.education_degree',
          'resource': 'education_degree'
        },
        {
          'type': 'slider-range',
          'label': this.$t('Salary'),
          'target': 'salary',
          'min': 0,
          'max': 50000,
          'interval': 1000,
          'format': '$ {value}'
        },
        {
          'type': 'slider-range-years',
          'label': this.$t('Age'),
          'target': 'birth_date',
          'min': 0,
          'max': 100,
          'interval': 1,
          'format': '{value}'
        },
        {
          'type': 'list',
          'label': this.$t('Languages'),
          'target': 'languages.language',
          'resource': 'languages'
        },
        {
          'type': 'list',
          'label': this.$t('Disability'),
          'target': 'disability',
          'resource': 'disabilities'
        },
        {
          'type': 'list',
          'label': this.$t('Gender'),
          'target': 'gender',
          'resource': 'genders'
        },
        {
          'type': 'list',
          'label': this.$t('Origin'),
          'target': 'origin',
          'resource': 'origins'
        },
        {
          'type': 'list',
          'label': this.$t('Source'),
          'target': 'source_id',
          'resource': 'sources'
        }
      ]
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    permissions () {
      return this.$store.getters.getPermissions
    },
    selected () {
      return this.$store.getters.getCandidateSelectedIds
    },
    job () {
      return this.$store.getters.getJob
    },
    candidates () {
      return this.$store.getters.getCandidates.map((v) => {
        v['placement'] = v.placements.filter((p) => { return p.job_id === this.job._id })[0] || {}
        return v
      })
    },
    paginate () {
      return this.$store.getters.getCandidatesPaginate
    },
    checkedAll () {
      return this.selected.length && !this.candidates.find(v => !this.selected.includes(v._id))
    },
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || '-created_at'
    }
  },
  created () {
    this.$store.dispatch('resetCandidateSelected')
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        'placements.elemMatch.job_id': this.job._id,
        page: this.$route.query.page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectCandidates', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.setPage(1)
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      if (filters.text) {
        this.$changeUrlParam({sort: '-score'})
      }

      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    /*
    toogleCheckAll
    */
    toggleCheckAll () {
      const checkedAll = this.checkedAll
      this.candidates.forEach((candidate) => {
        const action = checkedAll ? 'removeCandidateSelected' : 'addCandidateSelected'
        this.$store.dispatch(action, candidate._id)
      })
    },
    /*
    showCandidateCreateModal
    */
    showCandidateCreateModal () {
      this.candidate_create_modal = {
        job_id: this.job._id
      }
    },
    hideCandidateCreateModal () {
      this.candidate_create_modal = false
    },
    savedCandidateCreateModal (data) {
      this.loadData(this.paginate.page)
      this.hideCandidateCreateModal()
    },
    exportCandidates (fileType) {
      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        'placements.elemMatch.job_id': this.job._id,
        sort: this.sort
      }

      return this.axios.post('/accounts/' + this.$store.getters.getAccount._id + '/candidates/export', {
        file_type: fileType
      }, {
        params
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobGrid/JobGrid.vue